/**
 * Type-safe membership check for readonly string unions.
 * Prefer this over `(values as readonly string[]).includes(value)`.
 */
export function isOneOf<T extends string>(
  value: string,
  values: readonly T[],
): value is T {
  return new Set<string>(values).has(value)
}
